<template>
    <v-dialog  v-model="show_contract_modal" :persistent="persistent" :content-class="computed_pop_up_class">
        <v-card class="rounded-xl">
            <v-form ref="contractForm">
                <v-card-title class="d-flex justify-center">
                    <v-row class="justify-center">
                        <v-col cols="11" class="d-flex justify-center pa-0">
                            <span class="title">Selecciona el plan que quieres contratar</span>
                        </v-col>
                        <v-col cols="1" class="pa-0">
                            <span  @click="showPrices()">
                                <v-icon size="30" color="primary">mdi-information-outline</v-icon>
                            </span>
                        </v-col>
                    </v-row>
                </v-card-title>
                <v-divider />
                <v-card-text class="mt-0">
                    <div class="dialog-intro">
                        <p class="ma-0">{{contract_modal_msg}} Para poder seguir utilizando Inmatic debes seleccionar un nuevo plan y adjuntar el justificante de pago.</p>                        
                    </div>
                    <v-row class="dialog-content">                        
                        <v-col cols="12">                            
                            <app-modal-container>
                                <v-row class="no-gutters">                                   
                                    <v-col v-for="(s_type, index) in dialog_contract" :key="s_type" :cols="packages_cols" :class="{'pl-1': index!=0,'pr-1':index!=dialog_contract.length-1 }">
                                        <contract-select-plan-popup                                            
                                            v-if="services[s_type]"
                                            :key="index"                                            
                                            v-bind:selected_plan.sync="selected_plans_index"
                                            :services="services[s_type]"
                                            :contract_select_type="s_type"
                                        >
                                        </contract-select-plan-popup>
                                        <v-row v-if="s_type=='facturae_credits'">
                                            <v-col cols="6">
                                                <label>Número empresas</label>
                                                <v-text-field 
                                                    solo
                                                    class="promotional-code elevation-0 pa-0 ma-0"
                                                    label="Número empresas"
                                                    v-model="num_credits_custom"
                                                    outlined
                                                    dense
                                                    color="#66369b"
                                                    type="number"
                                                    :readonly="contract_modal_facturae_client"
                                                    >

                                                </v-text-field>
                                            </v-col>
                                            <v-col cols="6" v-if="contract_modal_facturae_client && userData && userData.user_role.value != 'customer' && userData.user_role.value != 'customer_consult'">
                                                {{ userData.user_role.value }}
                                                <label>*Solo con datos fiscales</label>
                                                <v-select                                                     
                                                    label="Selecciona cliente"
                                                    :items="client_users_facturae"
                                                    v-model="selected_user_contract_facturae"                                        
                                                    outlined                                                    
                                                    item-value="id"                
                                                    dense
                                                    :rules="[validationRules.select_required]"
                                                >
                                                <template v-slot:selection= "data">                                                    
                                                    {{ data.item.username }}
                                                </template>
                                                <template v-slot:item="data">
                                                    {{ data.item.username }}
                                                </template>
                                                </v-select>
                                            </v-col>
                                        </v-row>
                                    </v-col>                                    
                                </v-row>
                                <div class="red--text text-center mb-2" v-if="show_error_select_plan">Debes seleccionar al menos un plan.</div>                                
                                <v-row class="ma-0 pa-0">
                                    <v-col cols="6" md="6" class="ma-0 pr-2 pl-0 pt-0 pb-2">
                                        <div class="d-flex flex-column">
                                            <div class="total-price-title pb-2">TOTAL 
                                                <span v-if="check_selected_plan">{{ getTaxesFromString() }}</span>
                                                <span v-else>IMPUESTOS</span>
                                            </div>
                                            <div class="box-total-price" :class="check_selected_plan ? 'filled': 'empty'">
                                                <span v-if="check_selected_plan">{{ getAmountFromString() }}</span>
                                            </div>
                                        </div>                                         
                                    </v-col>
                                    <v-col cols="6" md="6" class="ma-0 pa-0" v-if="userData.available_features['feature_promotional_code']" align="right">
                                        <p class="text-right font-weight-light grey--text" v-if="!show_codigo_promo" @click="show_codigo_promo=true">
                                            ¿Tienes un código promocional?
                                        </p>
                                        <v-text-field
                                            v-else
                                            solo
                                            class="promotional-code elevation-0 pa-0 ma-0"
                                            label="Código promocional"
                                            v-model="promotional_code"
                                            outlined
                                            dense
                                            color="#66369b"
                                            :rules="[is_valid_code || 'Código promocional no válido']"
                                            :error="error_promotional_code"
                                            :error-messages="error_promotional_code_list"
                                            @input="on_promotional_code_changed"
                                        />
                                        <p class="contract-date my-0 py-0 text-right">
                                            <span class="font-weight-light black--text">Fin del contrato:</span> {{ end_date }}
                                        </p>
                                    </v-col>
                                    <v-col cols="6" md="6" class="ma-0 pa-0" v-else>
                                    </v-col>
                                    
                                </v-row>
                                <v-row class="pb-3">
                                    <v-col cols="12">
                                        <p class="ma-0 font-weight-light" :class="{ 'text-center': !is_single_contract }">Cuenta de Inmatic: <br v-if="is_single_contract"> <span class="font-weight-bold">BANCO SABADELL IBAN: ES04 0081 0400 1100 0123 0926</span> </p>
                                        <p class="ma-0 font-weight-light" :class="{ 'text-center': !is_single_contract }">En el beneficiario indique Coneptum S.L. En el concepto indique su usuario y el plan seleccionado. </p>
                                    </v-col>
                                </v-row>
                               
                                <div class="d-flex flex-column">
                                    <v-file-input 
                                        v-model="payment_file" 
                                        :rules="[validationRules.file_required]"                                        
                                        outlined
                                        prepend-icon=""
                                        prepend-inner-icon="mdi-paperclip"
                                        name="uploader"
                                        label="Adjuntar justificante de pago"
                                        class="file-input--outlined rounded-lg pb-2"
                                        hide-details
                                        dense
                                    > </v-file-input>
                                    <v-select v-if="userData.distributor_code && contract_modal_distributor"
                                        class="mt-2"
                                        label="Selecciona un usuario"
                                        :items="distributor_users"
                                        v-model="selected_user_contract"                                        
                                        outlined
                                        return-object
                                        item-text="username"
                                        item-value="id"                
                                        dense
                                        :rules="[validationRules.select_required]"
                                    >
                                    </v-select>
                                    <v-checkbox v-model="contract_accepted" :rules="[validationRules.required]"  class="my-0 py-0" hide-details>
                                        <template v-slot:label>
                                            <span class="small-font">
                                                He leído y acepto la
                                                <PolicyDialogLink 
                                                name="Adhesión a la prestación de servicios"
                                                >
                                                <LegalContract 
                                                    :params="{
                                                        postal_address: userData.postal_address,
                                                        province: userData.province,
                                                        bussnies_id: userData.bussnies_id,
                                                        business_name: userData.business_name,
                                                        name: userData.name,
                                                        docs_num: num_documents,
                                                        price: price,
                                                        date: contract_date
                                                    }"
                                                    kind="contract"
                                                    @contract-data="getServiceContractData"
                                                    />
                                                </PolicyDialogLink>
                                            </span>
                                        </template>
                                    </v-checkbox>
                                </div>                               
                            </app-modal-container>                                                                            
                        </v-col>
                        
                    </v-row>                
                </v-card-text>
                <v-card-actions class="mt-0 pt-0">
                    <app-modal-container>
                        <v-row class="ma-0" justify="center" align="center">
                            <v-col cols="12" md="8"  class="my-0 pa-0" align="left">
                                
                            </v-col>

                            <v-col cols="12" md="4" class="my-0 pa-0">
                                <v-row class="ma-0 pa-0">
                                    <v-col cols="6" class="my-0 pt-0 pr-2 pl-0 d-md-none d-lg-none d-xl-none">
                                        <v-btn 
                                            density="compact"
                                            name="Contratar" 
                                            size="x-small"
                                            elevation="0"
                                            color="primary" 
                                            class="primary-border"
                                            bg-color="white"
                                            outlined 
                                            dense
                                            block
                                            @click="closeContractModal()"
                                            >
                                            <span>Cancelar</span>
                                        </v-btn>
                                    </v-col>
                                    <v-col cols="6" md="12" class="my-0 pt-0 pl-2 pr-0">
                                        <v-btn 
                                            density="compact"
                                            name="Contratar" 
                                            size="x-small"
                                            color="#66369b"
                                            elevation="0"
                                            class="btn-purple"
                                            dense
                                            block
                                            :loading="contratando"
                                            @click="confirm()"
                                            >
                                            <span>Contratar</span>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </app-modal-container>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>

import { mapActions, mapGetters, mapState } from "vuex";
import { mapFields } from 'vuex-map-fields';
import PolicyDialogLink from "./WelcomeSteps/PolicyDialogLink";
import LegalContract from "./WelcomeSteps/LegalContract";
import { vuexPrefix } from "../store/vuex_utils";
import AppModalContainer from '@/components/layout/AppModalContainer.vue';
import ContractSelectPlanPopup from '@/components/ContractSelectPlanPopup.vue';
import { sync_command_dispatcher, query_dispatcher_abort } from "@/api/client";
import { DeliverAndCreateChargeForService } from '@/modules/revenue/app/DeliverAndCreateChargeForService'
import { ServicesPricesFiscalPositionQuery } from '@/modules/revenue/app/ServicesPricesFiscalPositionQuery';
import { DistributorUsersQuery } from '@/modules/revenue/app/DistributorUsersQuery';
import { ClientUsersQuery } from '@/modules/revenue/app/ClientUsersQuery';
import { S3Repository } from '@/modules/shared/infra/S3Repository';
import awsconfig from '../aws-exports';



export default {
    name: 'ContractPopup',
    components: {
        PolicyDialogLink,
        LegalContract,
        AppModalContainer,
        ContractSelectPlanPopup
    },
    props: {
    },
    data () {
        return {
            validationRules: {
                required: v => (v.toString()!='false') || 'Campo obligatorio',
                file_required: v => !!v || (v && v.size > 0) || 'Campo obligatorio',
                select_required: (v) => !!v || "Campo obligatorio",
            },
            services: {'invoices': [], 'banks': [], 'credits': [], 'facturae_credits': []},            
            selected_plans_index: {'invoices': false, 'banks': false, 'credits': false, 'facturae_credits': false},            
            num_credits_custom: 5,
            payment_method: 'transfer',
            charge_id: false,
            payment_file: null,
            creds:undefined,
            contratando:false,            
            is_valid_code_banks: true,
            is_valid_code_invoices: true,
            is_valid_code_credits: true,
            is_valid_code_facturae_credits: null,
            distributor_users: [],            
            selected_user_contract: null,
            client_users_facturae: [],
            selected_user_contract_facturae: null,
            show_error_select_plan: false, 
            show_codigo_promo: false
        }
    },
    async mounted() {
        this.calculateContractDate()
        this.selectPlan(undefined);
        this.calculateEndDate();
        this.services_prices_fiscal_position_query = new ServicesPricesFiscalPositionQuery(query_dispatcher_abort, this)
        for (let x in this.dialog_contract) {
            await this.services_prices_fiscal_position_query.run(null, this.dialog_contract[x])
        }        
        
        if (this.userData.distributor_code && this.contract_modal_distributor) {
            this.distributor_users_query = new DistributorUsersQuery(query_dispatcher_abort, this)
            await this.distributor_users_query.run()
        }
        if (this.contract_modal_facturae_client) {
            this.num_credits_custom = 1
            await new ClientUsersQuery(query_dispatcher_abort, this).run()
        }
        // this.getContractTypes().then(() => {
        //     this.setContractTypes(this.contract_types);
        // });
        // this.refreshUserData().then(() => {
        //     this.fillForm(this.userData);
        // });        
    },
    methods: {
        ...mapActions({
            refreshUserData: "me/refreshUserData",
            calculateEndDate: 'dialog_payment/calculateEndDate',
            selectPlan: 'dialog_payment/selectPlan',
            setServiceContract: 'dialog_payment/setServiceContract',
            calculateContractDate: 'dialog_payment/calculateContractDate',
            fillForm: 'dialog_payment/fillForm',
            setContractTypes: 'dialog_payment/setContractTypes',
            closeContractModal: 'dialog_payment/closeContractModal',            
            contractService: 'dialog_payment/contractService',
            setErrorPromotionalCode: 'dialog_payment/setErrorPromotionalCode',
            isValidPromotionalCode: 'contracts/isValidPromotionalCode',
            showPrices: 'dialog_payment/showPrices'
        }),
        getServiceContractData: function (data) {
            this.setServiceContract(data['full_version'])
        },
        is_valid_promotional_code(value, kind='invoices'){
            if (kind == 'invoices'){
                this.is_valid_code_invoices = value
            }
            else if (kind == 'banks') {
                this.is_valid_code_banks = value
            }   
            else if (kind == 'credits') {
                this.is_valid_code_credits = value
            }
            else if (kind == 'facturae_credits') {
                this.is_valid_code_facturae_credits = value
            }
        },       
        confirm: async function () { 
            this.contratando = true
            if (!this.check_selected_plan) {
                this.show_error_select_plan = true;
                this.contratando = false;                
            } else {            
                const formIsValid = this.$refs.contractForm.validate();
                if (formIsValid) {
                    this.creds = new AWS.CognitoIdentityCredentials({
                        IdentityPoolId: awsconfig['aws_cognito_identity_pool_id']
                    });
                    this.creds.params.Logins = this.creds.params.Logins || {};
                    this.creds.params.Logins['cognito-idp.eu-west-1.amazonaws.com/' + awsconfig['aws_user_pools_id']] =  this.session_information.signInUserSession.idToken.jwtToken;
                    this.creds.expired = true;
                    AWS.config.update({
                        region: awsconfig['aws_user_files_s3_bucket_region'],
                        credentials: this.creds,
                    });

                    // Por ahora solo dejamos contratar de uno en uno
                    let services_ids=[]
                    if (this.has_invoices && (this.selected_plans_index.invoices || this.selected_plans_index.invoices !== false)) {
                        services_ids.push(this.services['invoices'][this.selected_plans_index.invoices].service_id)
                    }
                    if (this.has_banks && (this.selected_plans_index.banks || this.selected_plans_index.banks !== false)) {
                        services_ids.push(this.services['banks'][this.selected_plans_index.banks].service_id)
                    }
                    if (this.selected_plans_index.credits || this.selected_plans_index.credits !== false) {
                        services_ids.push(this.services['credits'][this.selected_plans_index.credits].service_id)
                    }
                    if (this.selected_plans_index.facturae_credits || this.selected_plans_index.facturae_credits !== false) {
                        services_ids.push(this.services['facturae_credits'][this.selected_plans_index.facturae_credits].service_id)
                    }
                    let selected_user_contract_id;
                    if(this.selected_user_contract)
                        selected_user_contract_id = this.selected_user_contract.id
                    
                    let selected_user_contract_facturae_id;
                    if (this.contract_modal_facturae_client && this.selected_user_contract_facturae) {
                        selected_user_contract_facturae_id = this.selected_user_contract_facturae
                    }
                    else if (this.contract_modal_facturae_client && this.userData.user_role.value == 'customer' || this.userData.user_role.value == 'customer_consult') {
                        selected_user_contract_facturae_id = this.userData.user
                    }
                    await new DeliverAndCreateChargeForService(sync_command_dispatcher, new S3Repository(AWS), this)
                        .run(this.payment_method,
                            services_ids,
                            this.userData.user,
                            this.payment_file,
                            this.promotional_code,
                            Number(this.num_credits_custom),
                            selected_user_contract_id,
                            selected_user_contract_facturae_id
                        )
                    
                
                    // this.setErrorPromotionalCode(false);
                    // if (this.promotional_code) {
                    //     let callback = (result) => {
                    //         this.setErrorPromotionalCode(!result);
                    //         if (result) {
                    //             this.contractService();
                    //         }
                    //     }
                    //     this.isValidPromotionalCode(this.promotional_code).then(callback);
                    // } else {
                    //     this.contractService();
                    // }
                }
            }
            this.contratando = false
            
        },
        async move_to_profile(){
            await this.$router.push({ name: 'profile' })
        },
        async on_promotional_code_changed(){
            for (let x in this.dialog_contract) {
                await this.services_prices_fiscal_position_query.run(this.promotional_code, this.dialog_contract[x])    
            }            
        },
        closeMessage() {
            this.closeContractModal()
        },        
        getAmountFromString() { 
            let f_total = 0.0;
            for (let x in this.dialog_contract) {
                if ((this.selected_plans_index[this.dialog_contract[x]] != undefined) && this.selected_plans_index[this.dialog_contract[x]].toString() != 'false') {
                    if (this.dialog_contract[x] == 'facturae_credits' && this.num_credits_custom && this.num_credits_custom > 0) {
                        try {
                            let f_fact = parseFloat(this.services[this.dialog_contract[x]][this.selected_plans_index[this.dialog_contract[x]]]['total_with_taxes'].replace('Total ', '').split(":")[1].replace('€','').replace(".", "").replace(",", "."))
                            f_total += (f_fact * this.num_credits_custom)
                        }
                        catch (e){
                            return "ERROR";
                        }
                    }
                    else {
                        try {
                            f_total += parseFloat(this.services[this.dialog_contract[x]][this.selected_plans_index[this.dialog_contract[x]]]['total_with_taxes'].replace('Total ', '').split(":")[1].replace('€','').replace(".", "").replace(",", "."))
                        } 
                        catch (e){
                            return "ERROR";
                        }                                       
                    }
                }
            }
            if (f_total > 0){
                return (f_total.toFixed(2) + " €").replace('.', ',');
            }                          
        },
        getTaxesFromString() {
            try {
                if (this.has_invoices && this.has_banks){
                    if (this.selected_plans_index.invoices != undefined && this.selected_plans_index.invoices.toString() != 'false') {
                        return this.services['invoices'][this.selected_plans_index.invoices]['total_with_taxes'].replace('Total ', '').split(":")[0];
                    } else if (this.selected_plans_index.banks != undefined && this.selected_plans_index.banks.toString() != 'false') {
                        return this.services['banks'][this.selected_plans_index.banks]['total_with_taxes'].replace('Total ', '').split(":")[0];
                    }
                    else {
                        return '';
                    }
                } else if (this.has_invoices) {
                    return this.services['invoices'][this.selected_plans_index.invoices]['total_with_taxes'].replace('Total ', '').split(":")[0];
                } else if (this.has_banks) {
                    return this.services['banks'][this.selected_plans_index.banks]['total_with_taxes'].replace('Total ', '').split(":")[0];
                }
            }
            catch (e){
                console.log(e);
                return '';
            }
        },
        ...mapActions({
            forceRefreshUserData: "me/forceRefreshUserData",
            }),
    },
    computed: {
        ...mapGetters({
            userData: "me/userData",
            contract_modal_msg: "dialog_payment/contract_modal_msg",
            contract_modal_distributor: "dialog_payment/contract_modal_distributor",
            contract_modal_facturae_client: "dialog_payment/contract_modal_facturae_client"
        }),
        ...mapState(['session_information']),
        ...mapFields('contracts', ['contract_types']),
        ...mapFields('dialog_payment', ['end_date', 'contract_date', 'contract', 'promotional_code',
            'service_contract', 'price', 'num_documents', 'show_contract_modal',
            'persistent', 'width']),
        ...mapFields('dialog_payment', vuexPrefix('', ['promotional_code', 'contract_accepted', 'contract_type', 'error_promotional_code', 'error_promotional_code_list'], 'form.')),
        dialog_contract: function() {
            if (this.contract_modal_facturae_client) {
                return ["facturae_credits"];
            }
            if (this.userData.distributor_code && this.contract_modal_distributor) {
                return ["invoices", "banks"]; 
            }
            let aux = [];
            if (this.userData.available_features['feature_defaulter_user'] || this.userData.available_features['feature_contract_is_going_to_finish'] || this.userData.available_features['feature_trial_contract_is_finished']) {
                aux.push("invoices");
            }
            if (this.userData.available_features['feature_bank_contract_finished'] || this.userData.available_features['feature_bank_contract_is_going_to_finish'] || this.userData.available_features['feature_bank_trial_contract_is_finished']) {
                aux.push("banks");
            }
            if (this.userData.available_features['feature_show_triangle_contracts'] ){ //refactor in progress
                aux.push("credits");
            }
            if (this.userData.available_features['feature_can_buy_facturae'] ){ 
                aux.push("facturae_credits");
            }
            return aux;
        },
        computed_pop_up_class(){
            if (this.dialog_contract.length == 2){
                return 'elevation-0 ma-0 pa-0 contract-popup doble-contract'
            }
            else if (this.dialog_contract.length > 2){
                return 'elevation-0 ma-0 pa-0 contract-popup many-contract'
            }
            return 'elevation-0 ma-0 pa-0 contract-popup'
        },
        is_single_contract: function () { 
            return (this.dialog_contract.length == '1' ? true : false);
        },
        packages_cols(){
            return (12/this.dialog_contract.length).toString()
        },
        has_invoices: function () { 
            return (this.dialog_contract.includes('invoices'));
        },
        has_banks: function () { 
            return (this.dialog_contract.includes('banks'));
        },
        has_credits: function () { 
            return (this.dialog_contract.includes('credits'));
        },
        has_facturae_credits: function () { 
            return (this.dialog_contract.includes('facturae_credits'));
        },
        check_selected_plan: function () {
            for (let x in this.dialog_contract) {
                if ((this.selected_plans_index[this.dialog_contract[x]] != undefined) &&  this.selected_plans_index[this.dialog_contract[x]].toString() != 'false') {
                    this.show_error_select_plan = false;
                    return true;
                }
            }            
            return false;
        },
        is_valid_code: function() {
            if (this.has_invoices && this.is_valid_code_invoices){
                return this.is_valid_code_invoices
            }
            else if (this.has_banks && this.is_valid_code_banks){
                return this.is_valid_code_banks
            }
            else if (this.has_credits && this.is_valid_code_credits){
                return this.is_valid_code_credits
            }
            else if (this.has_facturae_credits && this.is_valid_code_facturae_credits){
                return this.is_valid_code_facturae_credits
            }
            return false
        },
    },
}
</script>

<style>
.v-dialog.contract-popup {
    border-radius: 8px !important;
    width: 600px !important;
}
.v-dialog.contract-popup.doble-contract {
    width: 920px !important;
}
.v-dialog.contract-popup.many-contract {
    width: 1300px !important;
}
.v-dialog.contract-popup .v-card__actions {
    padding-left:48px !important;
    padding-right:48px !important;
    padding-bottom: 10px !important;
}
.v-dialog.contract-popup.doble-contract .v-card__actions{
    padding-left:80px !important;
    padding-right:80px !important;
}
.v-dialog.contract-popup .v-card__text {
    padding-left:20px !important;
    padding-right:20px !important;
}
.v-dialog.contract-popup .v-card__text .dialog-content {
    padding-left:28px !important;
    padding-right:28px !important;
}
.v-dialog.contract-popup.doble-contract .v-card__text .dialog-content {
    padding-left:60px !important;
    padding-right:60px !important;
}
.v-dialog.contract-popup .v-card__text .dialog-intro{
    font-size:15px;
    font-weight: 300;
    text-align: center;
}
.v-dialog.contract-popup .v-card__text .contract-type {
    text-align: center;
    font-size: 20px;
    font-weight:700;
}
.v-dialog.contract-popup .file-input--outlined .v-input__prepend-inner .v-icon {
    font-size: 20px;
    width: 20px;
    height: 20px;
}
.contract-popup .promotional-code {
    max-width: 180px;
}
.v-dialog.contract-popup .promotional-code label,
.v-dialog.contract-popup .promotional-code input {
    font-size: 15px;
}

.v-dialog.contract-popup .promotional-code fieldset legend {
    width: 0px !important;
}

.v-dialog.contract-popup .promotional-code .v-text-field__details {
    margin-bottom:2px !important;
}
.v-dialog.contract-popup .promotional-code .v-input__control {
    min-height: 35px !important;
}
.v-dialog.contract-popup .promotional-code .v-input__slot {
    box-shadow: none !important;
    min-height: 35px !important;
    border-radius: 8px;
}
.v-dialog.contract-popup .v-input--radio-group .v-input__slot {
    margin-bottom: 0px !important;
}
.v-dialog.contract-popup .v-input--radio-group .v-messages {
    margin-bottom: 8px !important;
}

@media screen and (max-width: 920px) {
    .v-dialog.contract-popup.doble-contract {
        width: 95% !important;
    }    
    .v-dialog.contract-popup.doble-contract .v-card__actions{
        padding-left:20px;
        padding-right:20px;
    }
    .v-dialog.contract-popup.doble-contract .v-card__text .dialog-content {
        padding-left:20px !important;
        padding-right:20px !important;
    }
}

@media screen and (max-width: 600px) {
    .v-dialog.contract-popup  {
        width: 95% !important;
    }
    .v-dialog.contract-popup .v-card__actions {
        padding-left: 20px !important;
        padding-right: 20px !important;
    }
    .v-dialog.contract-popup .v-card__text .dialog-content {
        padding-left:0px !important;
        padding-right:0px !important;
    }
    .v-dialog.contract-popup.doble-contract .v-card__text .dialog-content {
        padding-left:0px !important;
        padding-right:0px !important;
    }
}

</style>

<style lang="scss" scoped>
span.title {
    color: #66369b
}

.plans {
    cursor: pointer;
    font-size: 0.80rem;
    background-color:white;
    &.selected {
        background-color: #dedcff;
    }
    &.disabled {
        opacity: 50%;
    }
    span {
        margin: auto;
    }
    border: 1px solid #66369b;
}
button.btn-purple {
    color: #ffffff;
}

span.mark-time {
    font-size: 1rem;
    color: #66369b;
}
span.mark-price {
    font-size: 1.2rem;
    color: #66369b;
    font-weight: 500;
}

p.contract-date {
    color: #66369b;
    font-weight: 500;
    font-size: 0.9rem;
    text-align: left;
}


.small-font {
    font-size: 0.80rem;
}
.promotional_code fieldset {
    color: white !important;
}

.contract-popup .total-price-title {
    font-size: 30px;
    font-weight: 500;
}
.contract-popup .total-price-title span {
    font-weight: 300;
    font-size: 20px;
}
.contract-popup .box-total-price {
    border-radius:8px;
    border:1px solid #565656;
    height: 32px;
    padding-top: 5px;
    padding-left:20px;
    padding-right:20px;
    font-weight: bold;
    font-size: 25px;
}
.contract-popup .box-total-price.filled {
    background-color: #f2f2f2;
}



</style>